<template>
  <!-- 巡回清掃 特別仕様（清掃前・清掃後）の PDF。夜のバッチが puppeteer で開いて PDF にする（RoundDownloadTemp と同じ仕組み） -->
  <div v-if="data">
    <!-- 表紙 -->
    <div class="a4-page cover">
      <div class="cover-frame">
        <div class="cover-title">清&#12288;掃&#12288;完&#12288;了&#12288;報&#12288;告&#12288;書</div>
        <!-- 館銘板の写真（その月の最初の報告書のもの） -->
        <div class="cover-plate"><img v-if="plateUrl" :src="plateUrl"></div>
        <div class="cover-lines">
          <div class="cover-line"><span class="cover-label">物件名称&#12288;：</span><span class="cover-value">{{ data.siteName }}</span></div>
          <div class="cover-line"><span class="cover-label">報告月&#12288;&#12288;：</span><span class="cover-value">{{ data.reportMonth }}</span></div>
        </div>
        <!-- 得意先名（支店名は付けない） -->
        <div class="cover-client">{{ data.clientName1 }}</div>
      </div>
    </div>

    <!-- 写真ページ（1 ページ 3 箇所。1 箇所＝左に清掃前・右に清掃後） -->
    <div v-for="(page, pi) in pages" :key="'pg' + pi" class="a4-page">
      <div class="photo-title">清&#12288;掃&#12288;報&#12288;告&#12288;写&#12288;真</div>
      <table class="site-table">
        <tr>
          <td class="site-label">物&#12288;件&#12288;名</td>
          <td class="site-value">{{ data.siteName }}</td>
        </tr>
      </table>

      <div class="photo-frame">
        <div v-for="(it, ri) in page" :key="'row' + pi + ri" class="photo-row" :class="ri === page.length - 1 ? 'last' : ''">
          <!-- ひと言の欄は左右とも常に同じ高さで確保（コメントの有無で写真の位置が変わらないように） -->
          <div class="photo-cell left">
            <div class="cell-head"><span>{{ it ? it.item : '' }}</span><span>{{ it ? '清掃前' : '' }}</span></div>
            <div class="cell-img"><img v-if="it && it.beforeUrl" :src="it.beforeUrl"></div>
            <div class="cell-note"></div>
          </div>
          <div class="photo-cell">
            <div class="cell-head"><span>{{ it ? it.item : '' }}</span><span>{{ it ? '清掃後' : '' }}</span></div>
            <div class="cell-img"><img v-if="it && it.afterUrl" :src="it.afterUrl"></div>
            <div class="cell-note">{{ it ? it.note : '' }}</div>
          </div>
        </div>
      </div>
      <div v-if="pi === pages.length - 1 && loading" id="loading" class="text-xss"></div>
    </div>
  </div>
</template>

<script>
import * as backend from '@libs/backend'
import * as utils from '@libs/utils'
import * as image from '@libs/image'

// 1 ページに置く箇所の数（ひな型どおり 3 段）
const PER_PAGE = 3

export default {
  data() {
    return {
      // rlsSpecial/pdf の結果
      data: null,
      // 写真ページ（箇所を 3 つずつに分けたもの。足りない段は null で空の枠）
      pages: [],
      // 表紙の館銘板の写真（data URL）
      plateUrl: '',
      // true になると PDF 化開始（puppeteer が #loading を待っている）
      loading: false
    }
  },

  async created() {
    // クエリから特別仕様の予定 id
    const id = this.$route.query.id
    const res = await backend.searchData('rlsSpecial/pdf', { id })
    const d = res.data && res.data.data
    if (d) {
      // 写真を data URL に
      for (const r of d.reports) {
        for (const it of r.items) {
          it.beforeUrl = it.before ? image.bufferToDataUrl(it.before) : ''
          it.afterUrl = it.after ? image.bufferToDataUrl(it.after) : ''
        }
      }
      // 表紙の館銘板はその月の最初の報告書のもの
      const first = d.reports.find((r) => r.plate)
      this.plateUrl = first ? image.bufferToDataUrl(first.plate) : ''
      this.data = d
      this.pages = this.toPages(d.reports)
    }

    await utils.wait(5000)
    this.loading = true
  },

  methods: {
    /**
     * 報告書（完了日ごと）の箇所を 3 つずつのページにする。同じ月の報告書が複数あれば順に続ける
     */
    toPages(reports) {
      const pages = []
      for (const r of reports) {
        for (let i = 0; i < r.items.length; i += PER_PAGE) {
          const page = r.items.slice(i, i + PER_PAGE)
          while (page.length < PER_PAGE) {
            page.push(null)
          }
          pages.push(page)
        }
      }
      return pages
    }
  }
}
</script>

<style scoped>
.a4-page {
  width: 210mm;
  height: 297mm;
  margin: 0 auto;
  padding: 15mm 12mm;
  background: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  font-family: "Noto Sans JP", "Hiragino Sans", "Meiryo", sans-serif;
  color: #000;
}

/* ---------- 表紙 ---------- */
.cover-frame {
  height: 100%;
  border: 2px solid #c00000;
  box-sizing: border-box;
  position: relative;
}

.cover-title {
  margin: 28mm 14mm 0 14mm;
  background: #2e5aa8;
  color: #fff;
  font-size: 22pt;
  font-weight: 700;
  text-align: center;
  padding: 7mm 0;
}

/* 館銘板の写真（題と物件名称の間） */
.cover-plate {
  position: absolute;
  top: 72mm;
  left: 45mm;
  right: 45mm;
  height: 60mm;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cover-plate img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.cover-lines {
  position: absolute;
  top: 160mm;
  left: 40mm;
  right: 40mm;
}

.cover-line {
  display: flex;
  align-items: baseline;
  font-size: 13pt;
  font-weight: 700;
  border-bottom: 1px dotted #333;
  padding: 2mm 2mm 1mm 2mm;
  margin-bottom: 8mm;
}

.cover-label {
  white-space: nowrap;
}

.cover-value {
  margin-left: 4mm;
  font-weight: 700;
}

.cover-client {
  position: absolute;
  top: 215mm;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 16pt;
  font-weight: 700;
}

/* ---------- 写真ページ ---------- */
.photo-title {
  text-align: center;
  font-size: 18pt;
  font-weight: 700;
  margin: 2mm 0 5mm 0;
}

.site-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 8mm;
}

.site-table td {
  border: 2px solid #000;
  padding: 2mm 3mm;
  font-size: 12pt;
  font-weight: 700;
}

.site-label {
  width: 32%;
  text-align: center;
}

.site-value {
  text-align: center;
}

.photo-frame {
  border: 2px solid #000;
  box-sizing: border-box;
  height: 232mm;
  display: flex;
  flex-direction: column;
}

.photo-row {
  flex: 1 1 0;
  display: flex;
  border-bottom: 1px solid #000;
  min-height: 0;
}

.photo-row.last {
  border-bottom: 0;
}

.photo-cell {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding: 2mm 3mm;
  position: relative;
}

.photo-cell.left {
  border-right: 1px solid #000;
}

.cell-head {
  display: flex;
  justify-content: space-between;
  font-size: 10pt;
  font-weight: 700;
  margin-bottom: 1.5mm;
  min-height: 5mm;
}

.cell-img {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cell-img img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.cell-note {
  flex: none;
  height: 11mm;
  font-size: 11pt;
  line-height: 1.3;
  margin-top: 1mm;
  white-space: pre-wrap;
  overflow: hidden;
}

/* 印刷時だけ適用 */
@media print {
  body {
    width: 210mm;
    height: 297mm;
  }

  .a4-page {
    box-shadow: none;
    page-break-after: always;
  }
}
</style>
